import React from 'react';
import { Auth } from 'aws-amplify';

import * as MESSAGES from '../Lib/Messages';
import BreadCrumb from './BreadCrumb';
import Notification from './Notification';
import InputError from './InputError';
import Validator from '../Lib/Validator';

class UserChangePass extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {},
			isError: false,
			errorMessage: '',
		};

		this.state = {...this.getInitialState(), ...this.state};
		this.handleChange = this.handleChange.bind(this);
	}

	getInitialState = () => ({
		old_password: '',
		new_password: '',
		confirm_password: '',
	});

	handleChange(event) {
		const { target: { name, value } } = event;
		this.setState({
			[name]: value
		});

		const { errors } = this.state;
		if(errors[name]) {
			delete errors[name];
		}
	}

	isValidation() {
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;
		var validator = new Validator();

		if(!validator.required(this.state.old_password)) {
			errors['old_password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(!validator.required(this.state.new_password)) {
			errors['new_password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if(!validator.minLength(this.state.new_password, 8)) {
			errors['new_password'] = MESSAGES.ERROR_MINLENGTH;
			isError = true;
		}
		if(!validator.required(this.state.confirm_password)) {
			errors['confirm_password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if(!validator.match(this.state.new_password, this.state.confirm_password)) {
			errors['confirm_password'] = MESSAGES.ERROR_CONFIRM_PASS;
			isError = true;
		}
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		if(isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	clearForm = () => {
		this.setState(this.getInitialState());
	}

	handleSave = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

	    Auth.currentAuthenticatedUser().then(user => {
	        return Auth.changePassword(user, this.state.old_password, this.state.new_password);
	    })
	    .then(data => {
			this.setState({errorMessage: MESSAGES.SUCCESS_RESET_PASSWORD, isError: false});
			this.clearForm();
		})
		.catch(err => {
			if(err.message) {
				this.setState({errorMessage: err.message, isError: true});
			}
		});
	}

	render() {
		const { errors, isError, errorMessage } = this.state;
		return (
			<section role="main" className="content-body">
				<header className="page-header">
					<h2>Change Password</h2>
					<BreadCrumb title1="User" title2="Change Password" />
				</header>

				<Notification isError={isError} message={errorMessage} />

				<div className="row">
					<div className="col">
						<section className="card">
							<div className="card-body">
								<form className="form-horizontal form-bordered" method="POST">
									<div className={`form-group row ${errors.old_password ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">Old Password</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-lock"></i>
												</span>
												<input type="password" name="old_password" className="form-control" value={this.state.old_password} onChange={this.handleChange} />
											</div>
											<InputError error={errors.old_password} />
										</div>
									</div>

									<div className={`form-group row ${errors.new_password ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">New Password</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-lock"></i>
												</span>
												<input type="password" name="new_password" className="form-control" value={this.state.new_password} onChange={this.handleChange} />
											</div>
											<InputError error={errors.new_password} />
										</div>
									</div>

									<div className={`form-group row ${errors.confirm_password ? 'has-danger' : null}`}>
										<label className="col-lg-3 control-label text-lg-right pt-2">Confirm Password</label>
										<div className="col-lg-6">
											<div className="input-group">
												<span className="input-group-addon">
													<i className="fa fa-lock"></i>
												</span>
												<input type="password" name="confirm_password" className="form-control" value={this.state.confirm_password} onChange={this.handleChange} />
											</div>
											<InputError error={errors.confirm_password} />
										</div>
									</div>
								</form>
							</div>

							<footer className="card-footer">
								<div className="row justify-content-end">
									<div className="col-sm-9">
										<button type="submit" className="btn btn-primary" onClick={this.handleSave}>Confirm</button>
										<button type="reset" className="btn btn-default" onClick={this.clearForm}>Reset</button>
									</div>
								</div>
							</footer>
						</section>
					</div>
				</div>
			</section>
    	)
	}
}

export default UserChangePass;
